import React, {PropsWithChildren, useContext} from "react"
import {
	Claims,
	useIsBankUser,
	useIsOrgUser,
	useIsPartnerUser,
	useIsUnitAdminOrgAdminBankOperationsOnly,
	useIsUnitAdminReadonlyUser,
	useIsUnitAdminUser,
	useIsUnitUser,
} from "../../services/auth"
import {claimsContext} from "../../services/claims"
import {isOrgManageResubmitApplication} from "../../resources/orgPolicy"
import {hasPermission, useIsAllowedToEvaluate} from "../../services/permission"
import {Assignee} from "../../resources/application"

export function UnitUserOnly({children}: PropsWithChildren<{}>) {
	if (useIsUnitUser()) return <>{children}</>
	return null
}

export function UnitAdminOnly({children, claims}: PropsWithChildren<{claims?: Claims}>) {
	if (useIsUnitAdminUser(claims)) return <>{children}</>
	return null
}

export function UnitAdminReadOnly({children, claims}: PropsWithChildren<{claims?: Claims}>) {
	if (useIsUnitAdminReadonlyUser(claims)) return <>{children}</>
	return null
}

export function UnitAdminOrgAdminBankOperationsOnly({children}: PropsWithChildren<{}>) {
	const isUnitAdminOrgAdminBankOperationsOnly = useIsUnitAdminOrgAdminBankOperationsOnly()

	if (isUnitAdminOrgAdminBankOperationsOnly) return <>{children}</>
	return null
}

export function UnitOrOrgOrPartnerOnlyUser({children}: PropsWithChildren<{}>) {
	const isUnitUser = useIsUnitUser()
	const isOrgUser = useIsOrgUser()
	const isPartnerUser = useIsPartnerUser()

	if (isUnitUser || isOrgUser || isPartnerUser) return <>{children}</>
	return null
}

export function UnitOrBankUserOnly({children}: PropsWithChildren<{}>) {
	const isUnitUser = useIsUnitUser()
	const isBankUser = useIsBankUser()

	if (isUnitUser || isBankUser) return <>{children}</>
	return null
}

export function UnitOrOrgManageResubmitOrBankOnly({children}: PropsWithChildren<{}>) {
	return useIsAllowedToPreviewApprovalRejectInformation() ? <>{children}</> : null
}

export function useIsAllowedToPreviewApprovalRejectInformation() {
	if (useIsUnitUser() || useIsBankUser()) {
		return true
	} else {
		const orgId = useContext(claimsContext)?.orgId
		return orgId && hasPermission("application.applicationDecision", "get") && isOrgManageResubmitApplication(orgId)
	}
}

export function AllowedToViewEvaluation({children, applicationOrgId}: PropsWithChildren<{applicationOrgId: string}>) {
	if (useIsAllowedToEvaluate(applicationOrgId, false)) return <>{children}</>
	return null
}

export function AllowedToEvaluateUserOnly({
	children,
	applicationOrgId,
	assignee,
}: PropsWithChildren<{applicationOrgId: string; assignee: Assignee}>) {
	if (useIsAllowedToEvaluate(applicationOrgId, true, assignee)) return <>{children}</>
	return null
}
